import { Theme } from '@material-ui/core';

export const buildDrawerTransition = (theme: Theme) =>
    theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    });
